import {
  useReorderPositionKanbanMutation,
  ReorderPositionKanbanMutationVariables,
} from "@/features/projects/graphql/generated";

export const useReorderKanbanPosition = () => {
  const [mutate, { loading }] = useReorderPositionKanbanMutation();

  const handleReorderKanbanPosition = async (
    variables: ReorderPositionKanbanMutationVariables
  ) => {
    await mutate({ variables, refetchQueries: ["Project"] });
  };

  return {
    handleReorderKanbanPosition,
    loading,
  };
};
